<template>
    <el-button type="primary">test</el-button>
</template>

<script>
export default {
  name:'OccSTable'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/OccSTable/OccSTable.vue